import { type ReactNode } from 'react';
import { PluginApiContext } from './PluginApiContext';
import type { PluginApiClient } from './types';

export function PluginApiProvider({
  client,
  children,
}: {
  client: PluginApiClient;
  children: ReactNode;
}) {
  return (
    <PluginApiContext.Provider value={client}>
      {children}
    </PluginApiContext.Provider>
  );
}
